import { createSection } from "./structure";

// The section headings of a pharmacovigilance system master file, following
// GVP Module II. Loaded as a starting point and then renamed, extended or cut
// back to whatever the document being assembled needs.
const OUTLINE = [
  ["Introduction", ["Purpose and scope", "Structure of this document"]],
  [
    "Qualified Person Responsible for Pharmacovigilance",
    ["Identity and contact details", "Responsibilities", "Deputy and back-up arrangements"]
  ],
  [
    "Organisational structure of the marketing authorisation holder",
    ["Organisation charts", "Pharmacovigilance department", "Contracts and agreements"]
  ],
  [
    "Sources of safety data",
    ["Solicited sources", "Unsolicited sources", "Scientific literature", "Regulatory authorities"]
  ],
  ["Computerised systems and databases", ["Safety database", "Validation and change control"]],
  [
    "Pharmacovigilance processes",
    [
      "Case management",
      "Signal management",
      "Risk management",
      "Periodic safety reporting",
      "Safety variations and communication"
    ]
  ],
  ["Pharmacovigilance system performance", ["Performance indicators", "Compliance monitoring"]],
  [
    "Quality system",
    ["Written procedures", "Training", "Auditing", "Record management and archiving"]
  ],
  ["Annexes", []]
];

export const psmfOutline = () =>
  OUTLINE.map(([title, children]) => ({
    ...createSection(title),
    children: children.map((child) => createSection(child))
  }));
